(function(){
function init(root){
  var $=function(s){return root.querySelector(s)};
  var $$=function(s){return Array.prototype.slice.call(root.querySelectorAll(s))};

  var endStr=root.getAttribute('data-promo-end'), promoOver=false;
  if(endStr){var end=new Date(endStr); if(!isNaN(end.getTime()) && Date.now()>end.getTime()) promoOver=true;}
  if(promoOver){
    $$('[data-zq-promo]').forEach(function(el){el.hidden=true});
    var lbl=$('[data-zq-atc-label]'), reg=root.getAttribute('data-label-regular');
    if(lbl && reg) lbl.textContent=reg;
    $$('[data-zq-regular-label]').forEach(function(el){var t=el.getAttribute('data-zq-regular-label'); if(t) el.textContent=t;});
  }

  var track=$('[data-zq-track]'), thumbs=$$('[data-zq-thumb]'), dots=$$('.zq-dot');
  function goTo(i){ if(!track) return; var sl=track.querySelectorAll('.zq-gallery__slide')[i]; if(sl) track.scrollTo({left:sl.offsetLeft,behavior:'smooth'}); }
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(+t.getAttribute('data-zq-thumb'))})});
  if(track){
    var tick;
    track.addEventListener('scroll',function(){
      cancelAnimationFrame(tick);
      tick=requestAnimationFrame(function(){
        var i=Math.round(track.scrollLeft/track.clientWidth);
        thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===i)});
        dots.forEach(function(d,n){d.classList.toggle('is-active',n===i)});
      });
    },{passive:true});
  }

  var input=$('[data-zq-variant-input]'), atcBtn=$('[data-zq-atc]'), atcPrice=$('[data-zq-atc-price]');
  var stickyPrice=$('[data-zq-sticky-price]'), stickyName=$('[data-zq-sticky-name]');
  var bundles=$$('[data-zq-bundle]');
  function select(card){
    if(card.classList.contains('is-soldout')) return;
    bundles.forEach(function(b){b.classList.toggle('is-selected',b===card); var r=b.querySelector('input'); if(r) r.checked=(b===card);});
    input.value=card.getAttribute('data-variant');
    var price=card.getAttribute('data-price');
    if(atcPrice) atcPrice.textContent=price;
    if(stickyPrice) stickyPrice.textContent=price;
    if(stickyName) stickyName.textContent=card.getAttribute('data-name');
    if(atcBtn) atcBtn.disabled=false;
    var mid=card.getAttribute('data-media');
    if(mid && track){
      var slides=track.querySelectorAll('.zq-gallery__slide');
      for(var i=0;i<slides.length;i++){ if(slides[i].getAttribute('data-media-id')===mid){goTo(i);break;} }
    }
  }
  bundles.forEach(function(card){
    var r=card.querySelector('input');
    if(r) r.addEventListener('change',function(){select(card)});
  });

  var form=$('[data-zq-form]'), msg=$('[data-zq-msg]');
  if(form && window.fetch){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!input.value) return;
      atcBtn.disabled=true; if(msg) msg.textContent='';
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:+input.value,quantity:1}]})})
      .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
      .then(function(res){
        if(!res.ok) throw new Error((res.d&&(res.d.description||res.d.message))||'Er ging iets mis.');
        window.location.href = root.getAttribute('data-after-add')==='checkout' ? base+'checkout' : base+'cart';
      })
      .catch(function(err){ if(msg) msg.textContent=err.message||'Er ging iets mis. Probeer het opnieuw.'; atcBtn.disabled=false; });
    });
  }

  $$('[data-zq-scroll]').forEach(function(a){
    a.addEventListener('click',function(e){var t=root.querySelector('#zq-offer'); if(t){e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'});}});
  });

  var sticky=$('[data-zq-sticky]'), offer=$('#zq-offer');
  if(sticky && offer && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      var en=entries[0], past=!en.isIntersecting && en.boundingClientRect.top<0;
      sticky.classList.toggle('is-visible',past); sticky.setAttribute('aria-hidden',past?'false':'true');
      var a=sticky.querySelector('a'); if(a) a.tabIndex=past?0:-1;
    },{threshold:0}).observe(offer);
  }

  var vids=$$('.zq-ugc__card video');
  if(vids.length && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){var v=en.target; if(en.isIntersecting){v.preload='auto'; var p=v.play(); if(p&&p.catch)p.catch(function(){});} else {v.pause();}});
    },{threshold:.6});
    vids.forEach(function(v){v.muted=true; v.setAttribute('playsinline',''); io.observe(v)});
  }
}
function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-zq-root]'),function(r){if(!r.__zq){r.__zq=1;init(r);}});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
document.addEventListener('shopify:section:load',boot);
})();